/* src/app/pages/new-analysis/new-analysis.component.scss */
.fill-remaining-space {
  flex: 1 1 auto;
}
.container {
  padding: 10px;
  margin: 20px;
}
.form {
  min-width: 150px;
  max-width: 700px;
  width: 100%;
}
.form-element {
  padding: 5px 0px 25px 2px;
  width: 100%;
}
.button {
  margin: 75px 1px;
}
.error {
  font-size: 12px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 10px;
}
.grid-item {
  width: 100%;
}
.grid-content {
  display: block;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 10px;
}
::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
}
.mat-mdc-form-field {
  --mat-mdc-form-field-floating-label-scale: 0.75;
  display: block;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}
/*# sourceMappingURL=new-analysis.component.css.map */
